<template>

  <div>
    <!-- supplier Modal -->
    <b-modal
        v-model="showModalInternal"
        id="supplier-select-modal-form"
        scrollable
        :title="title"
        title-class="font-18"
        size="xl"
        style="z-index:100010!important;"
        hide-footer


    >

        <SupplierDataList :multiselect="multiselect" @onSelect="selectSuppliers"
                          @onSelectRow="selectSupplierRow"
                          :showRowActions="showRowActions"
                          :showMassActions="showMassActions"
                          :selectedSuppliersData="selectedSuppliersData"
                          :showAddButton="showAddButton"
                          :showCheckboxColumn="showCheckboxColumn"
                          :enableRowSelection="enableRowSelection"
                          :visibleColumnsFilter="visibleColumnsFilter"
        >

          <template #bottom>
            <div class="modal-footer-container">
              <div class="modal-footer-bottom">
                <button class="btn btn-primary" @click="applySelectSupplier" :disabled="!selectedSuppliers || selectedSuppliers.length === 0">{{ okTitle }}</button>
              </div>

            </div>

          </template>

        </SupplierDataList>



    </b-modal>
  </div>



</template>
<script>
import {defineComponent} from 'vue'
import SupplierDataList from "./SupplierDataList.vue";
import {BModal} from "bootstrap-vue-next";
export default defineComponent({
  name: "SupplierListModal",
  props: {
    showModal:{
      type: Boolean,
     required: true
    },
    multiselect: {
      type: Boolean,
      default: true,
    },
    showMassActions: {
      type: Boolean,
      default: () => true
    },
    showRowActions: {
      type: Boolean,
      default: () => true
    },
    showAddButton: {
      type: Boolean,
      default: () => true
    },
    selectedSuppliersData: {
      type: Array,
      default: () => []
    },
    title:{
      type:String,
      default: ()=>"Wybierz dostawcę"
    },
    okTitle:{
      type:String,
      default: ()=>"Wybierz"
    },
    showCheckboxColumn: {
      type: Boolean,
      default: () => true
    },
    enableRowSelection: {
      type: Boolean,
      default: () => true
    },
    visibleColumnsFilter:{ // declare only columns keys You want to see
      type:Array,
      default: ()=>[]
    }

  },
  emits: ["update:showModal","onApply","onClose"],
  components: {SupplierDataList,BModal},
  data(){
    return {
      showModalInternal:this.showModal,
      selectedSuppliers:null,

    }
  },
  methods:{
    selectSuppliers(itemsData){
      this.selectedSuppliers = itemsData
    },
    selectSupplierRow(supplier){
      this.selectedSuppliers = [supplier]
    },



    applySelectSupplier(){
      console.log("Selected suppliers " + this.selectedSuppliers)
      this.$emit("onApply",this.selectedSuppliers)
    },
    closeModal(){
      this.showModalInternal = false
      this.$emit("onClose")
    }
  },
  watch:{
    // Watch parent prop changes and sync
    showModal(newValue) {
      this.showModalInternal = newValue;
    },
    // Watch local copy and emit to parent
    showModalInternal(newValue) {
      this.$emit('update:showModal', newValue);
    }
  },
  created(){
  }
})
</script>
<style scoped>
.modal-footer-container {
  position: sticky;
  bottom: -19px;
  left: 0;
  width: 100%;
  background: #fff;
  z-index: 60;
  padding: 0;
}

.modal-footer-bottom {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 18px 24px;
}
</style>
